// extracted by mini-css-extract-plugin
var _1 = "PanelIconImage_gradient__b0b25";
var _2 = "PanelIconImage_icon__86f88";
var _3 = "PanelIconImage_img__ca880";
export { _1 as "gradient", _2 as "icon", _3 as "img" }
